<template>
  <div :class="isLoading ? 'is-loading' : ''">
    <!-- filters -->
    <aside class="d-print-none">
      <!-- sections -->
      <ul
        class="nav nav-pills flex-nowrap flex-md-wrap gap-3 overflow-auto overflow-md-visible pt-2 pb-3 mb-4 px-2 px-md-0"
      >
        <li class="nav-item">
          <button
            :class="[
              'text-uppercase nav-link shadow fs-7 px-4 py-2 text-nowrap',
              filters.section === '' ? 'active' : ''
            ]"
            @click="selectSection('')"
          >
            {{ translate('All') }}
          </button>
        </li>
        <li class="nav-item" v-for="section in sections" :key="section.id">
          <button
            :class="[
              'text-uppercase nav-link shadow fs-7 px-4 py-2 text-nowrap',
              filters.section === section.id ? 'active' : ''
            ]"
            @click="selectSection(section.id)"
          >
            {{ section.title }}
          </button>
        </li>
      </ul>
    </aside>

    <!-- sections -->
    <template v-for="section in displayedItems" :key="section.id">
      <section class="mb-4" v-if="section.people.length">
        <h2 class="h3 mb-4">
          <u>{{ section.title }}</u>
        </h2>

        <div class="row">
          <div
            class="col-lg-6 mb-4"
            v-for="person in section.people"
            :key="person.id"
          >
            <div
              class="p-4 h-100 shadow rounded-1 shadow d-flex flex-column flex-sm-row text-secondary"
            >
              <div class="flex-shrink-0 mb-4 mb-sm-0 text-center text-sm-left">
                <div
                  :class="[
                    person.description.length
                      ? 'PeoplePersonAvatar cursor-pointer'
                      : null,
                    'd-inline-block overflow-hidden rounded-circle'
                  ]"
                  :data-bs-toggle="person.description.length ? 'modal' : null"
                  :data-bs-target="
                    person.description.length ? '#' + modalId(person.id) : null
                  "
                >
                  <img
                    :src="getPersonImage(person.image)"
                    :alt="person.name"
                    class="img-fluid"
                  />
                </div>
              </div>
              <div class="ps-sm-4 d-flex flex-column">
                <h3
                  :class="[
                    person.description.length
                      ? 'cursor-pointer text-decoration-underline'
                      : null,
                    'h6 mb-2'
                  ]"
                  :data-bs-toggle="person.description.length ? 'modal' : null"
                  :data-bs-target="
                    person.description.length ? '#' + modalId(person.id) : null
                  "
                >
                  {{ person.name }}
                </h3>
                <p class="mb-2">
                  {{ person.position }}
                </p>
                <div class="mt-auto text-nowrap">
                  <p v-if="person.mail.length" class="mb-1">
                    <strong class="pe-1">{{ translate('Email') }}:</strong>
                    <a :href="`mailto:${person.mail}`" class="link-secondary">
                      {{ person.mail }}
                    </a>
                  </p>
                  <p v-if="person.phone.length">
                    <strong class="pe-1">{{ translate('Phone') }}:</strong>
                    <a :href="`tel:${person.phone}`" class="link-secondary">
                      {{ person.phone }}
                    </a>
                  </p>
                </div>
              </div>
            </div>

            <!-- Modal -->
            <div
              v-if="person.description.length"
              class="modal fade"
              :id="modalId(person.id)"
              tabindex="-1"
              :aria-labelledby="modalId(person.id) + '-label'"
              aria-hidden="true"
            >
              <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                  <div class="modal-header">
                    <h1
                      class="modal-title fs-5"
                      :id="modalId(person.id) + '-label'"
                    >
                      {{ person.name }}
                    </h1>
                    <button
                      type="button"
                      class="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <div class="modal-body">
                    <div class="editor" v-html="person.description"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </template>
  </div>
</template>

<script>
import { translate } from '@/scripts/mixins/translations'

export default {
  mixins: [translate],
  data () {
    return {
      isLoading: false,
      filters: {
        section: ''
      },
      sections: []
    }
  },
  methods: {
    getPersonImage (url) {
      if (url.length) {
        return url
      }

      return '/client-assets/public/images/tc-placeholder.svg'
    },
    selectSection (id) {
      if (!id || !this.sections.find(section => section.id === id)) {
        this.filters.section = ''
      } else {
        this.filters.section = id
      }
    },
    loadPeople () {
      this.isLoading = true

      axios
        .get(`people/list`)
        .then(response => {
          const { data } = response

          this.sections = data
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    modalId (personid) {
      return `personModal-${personid}`
    }
  },
  computed: {
    filteredItems () {
      let list = this.sections

      if (this.filters.section) {
        list = list.filter(section => {
          return section.id === this.filters.section
        })
      }

      return list
    },
    displayedItems () {
      return this.filteredItems
    }
  },
  mounted () {
    this.loadPeople()
  }
}
</script>
